import Vue from 'vue';

Vue.config.errorHandler = (err, vm) => {
  vm.$rollbar.error(err);
  throw err;
};
